"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolAccount = void 0;
var Base_1 = require("./../Base");
var SchoolAccount = /** @class */ (function (_super) {
    __extends(SchoolAccount, _super);
    function SchoolAccount() {
        return _super.call(this) || this;
    }
    return SchoolAccount;
}(Base_1.BaseModel));
exports.SchoolAccount = SchoolAccount;
//# sourceMappingURL=Account.js.map